import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraBadge, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraTooltip } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { companyRoles, ROLE_LABEL } from '../records/company/companyIdentity';
const VARIANT = {
    OURS: 'dark',
    PARTNER: 'success',
    COMPETITOR: 'danger',
    PRIME_WE_SUB_TO: 'info',
    TEAMMATE: 'success',
    OUR_SUB: 'success'
};
const MAX_CHIPS = 3;
/**
 * The Companies tab "To us" cell (SAD-1333): every current role as its own
 * chip, in priority order — a company can be a partner, a competitor and our
 * sub at once. More than three collapse into "+n" with the rest in a tooltip.
 * The top role's server qualifier (e.g. "former sub on CCSS") follows as
 * muted text; with no current role, the most relevant former one shows instead.
 */ export function CompanyRoleChips({ relationships }) {
    const { current, former } = companyRoles(relationships);
    const kinds = [
        ...new Set(current.map((c)=>c.kind))
    ];
    if (kinds.length === 0) {
        const f = former[0];
        return f ? /*#__PURE__*/ _jsx(SpecraText, {
            size: "meta",
            tone: "muted",
            children: f.qualifier || `former ${f.label.charAt(0).toLowerCase()}${f.label.slice(1)}`
        }) : '—';
    }
    const shown = kinds.slice(0, MAX_CHIPS);
    const rest = kinds.slice(MAX_CHIPS);
    const contexts = (kind)=>current.filter((c)=>c.kind === kind).map((c)=>c.label).join(' · ');
    return /*#__PURE__*/ _jsxs("span", {
        className: "flex flex-wrap items-center gap-1",
        children: [
            shown.map((k)=>/*#__PURE__*/ _jsx(SpecraTooltip, {
                    content: contexts(k),
                    children: /*#__PURE__*/ _jsx(SpecraBadge, {
                        variant: VARIANT[k] ?? 'neutral',
                        "data-testid": Testids.registryCompany.listRoleChip,
                        children: ROLE_LABEL[k] ?? k
                    })
                }, k)),
            rest.length > 0 && /*#__PURE__*/ _jsx(SpecraTooltip, {
                content: rest.map((k)=>contexts(k)).join(' · '),
                children: /*#__PURE__*/ _jsxs(SpecraBadge, {
                    variant: "neutral",
                    "data-testid": Testids.registryCompany.listRoleOverflow,
                    children: [
                        "+",
                        rest.length
                    ]
                })
            }),
            current[0]?.qualifier && /*#__PURE__*/ _jsx(SpecraText, {
                size: "meta",
                tone: "muted",
                children: current[0].qualifier
            })
        ]
    });
}
